var hashtag_default = {
  "fontElementMap": "isKq3",
  "hashtag": "WPXMm"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
